import script from "./GroupActivityTableMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupActivityTableMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./style.css?vue&type=style&index=0&id=8ce587aa&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce587aa"]])

export default __exports__